import React, { useState } from 'react';
import SimpleBar from 'simplebar-react';
import { useLocation } from 'react-router-dom';
// import { isMobile } from 'react-device-detect';
import { CSSTransition } from 'react-transition-group';
import { useSelector } from 'react-redux';
import {
  // ArchiveIcon,
  CalendarIcon,
  ChartBarIcon,
  ChartPieIcon,
  // ClipboardListIcon,
  // CogIcon,
  CreditCardIcon,
  // InboxIcon,
  InformationCircleIcon,
  // LocationMarkerIcon,
  // NewspaperIcon,
  TableIcon,
  // TemplateIcon,
  // UsersIcon,
  // ViewGridIcon,
  CashIcon,
  XIcon,
  ExclamationCircleIcon,
  MailIcon,
  QuestionMarkCircleIcon,
  // PlusSmIcon,
  // ViewListIcon,
  DocumentTextIcon,
  UserGroupIcon,
} from '@heroicons/react/solid';
import { LogoutIcon, HomeIcon } from '@heroicons/react/outline';
import { Sparkles, Dna } from 'lucide-react';
import { Nav, Badge, Image, Button, Dropdown, Navbar, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '#hooks';
import UnitedKingdomFlag from '#assets/img/flags/gb.svg';
import PlFlag from '#assets/img/flags/pl.svg';

import { useTranslation } from 'react-i18next';
import { Routes } from '#Routes';

/** Zawsze widoczne pozycje PL/EN (Collapse w SimpleBar potrafił ukrywać podmenu języka). */
function SidebarLanguageSection({ onItemClick }) {
  const { t, i18n } = useTranslation();
  const current = String(i18n.language || '')
    .toLowerCase()
    .startsWith('pl')
    ? 'pl'
    : 'en';

  const changeLanguage = (lang) => (e) => {
    e.preventDefault();
    i18n.changeLanguage(lang);
  };

  return (
    <>
      <Nav.Item className='mt-2 pt-2 border-top border-secondary border-opacity-25'>
        <div className='nav-link py-1 mb-0 text-white-50 small text-uppercase sidebar-text' role='presentation'>
          {t('sidebar.languages')}
        </div>
      </Nav.Item>
      <Nav.Item className={current === 'pl' ? 'active' : ''} onClick={() => onItemClick?.()}>
        <Nav.Link href='#' className='d-flex align-items-center' onClick={changeLanguage('pl')}>
          <img
            src={PlFlag}
            alt=''
            width={20}
            height={20}
            className='sidebar-icon flex-shrink-0 rounded'
            style={{ objectFit: 'cover' }}
          />
          <span className='sidebar-text'>{t('languages.pl')}</span>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item className={current === 'en' ? 'active' : ''} onClick={() => onItemClick?.()}>
        <Nav.Link href='#' className='d-flex align-items-center' onClick={changeLanguage('en')}>
          <img
            src={UnitedKingdomFlag}
            alt=''
            width={20}
            height={20}
            className='sidebar-icon flex-shrink-0 rounded'
            style={{ objectFit: 'cover' }}
          />
          <span className='sidebar-text'>{t('languages.en')}</span>
        </Nav.Link>
      </Nav.Item>
    </>
  );
}

export const Sidebar = (props = {}) => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const { userToken } = useSelector((state) => state.auth);
  // const contracted = props.contracted ? 'contracted' : '';
  const onCollapse = () => setShow(!show);
  // const onMouseEnter = () => props.onMouseEnter && props.onMouseEnter();
  // const onMouseLeave = () => props.onMouseLeave && props.onMouseLeave();

  const NavItem = (props) => {
    const {
      title,
      onClick,
      link,
      target,
      icon: NavItemIcon,
      image,
      badgeText,
      badgeBg,
      badgeColor = 'white',
    } = props;
    const classNames = badgeText ? 'd-flex align-items-center justify-content-between' : '';
    const navItemClassName = link === pathname ? 'active' : '';

    // Special case for logout to prevent path concatenation
    if (title === t('sidebar.items.logout')) {
      return (
        <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
          <Nav.Link
            as='a'
            href='/'
            className={classNames}
            onClick={(e) => {
              e.preventDefault();
              onClick();
            }}
          >
            <span>
              {NavItemIcon && (
                <span className='sidebar-icon'>
                  <NavItemIcon className='icon icon-xs me-2' />
                </span>
              )}
              <span className='sidebar-text'>{title}</span>
            </span>
          </Nav.Link>
        </Nav.Item>
      );
    }

    // Akcje bez trasy (np. język) — <Link to=""> w podmenu potrafi nie renderować się poprawnie
    if (onClick && (link == null || link === '')) {
      return (
        <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
          <Nav.Link
            href='#'
            className={classNames}
            onClick={(e) => {
              e.preventDefault();
              onClick(e);
            }}
          >
            <span>
              {NavItemIcon && (
                <span className='sidebar-icon'>
                  <NavItemIcon className='icon icon-xs me-2' />
                </span>
              )}

              {image ? (
                <Image src={image} width={20} height={20} className='sidebar-icon svg-icon' />
              ) : null}

              <span className='sidebar-text'>{title}</span>
            </span>

            {badgeText ? (
              <Badge pill bg={badgeBg} text={badgeColor} className='badge-sm notification-count'>
                {badgeText}
              </Badge>
            ) : null}
          </Nav.Link>
        </Nav.Item>
      );
    }

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link
          as={Link}
          to={link ?? ''}
          target={target}
          className={classNames}
          onClick={onClick}
        >
          <span>
            {NavItemIcon && (
              <span className='sidebar-icon'>
                <NavItemIcon className='icon icon-xs me-2' />
              </span>
            )}

            {image ? (
              <Image src={image} width={20} height={20} className='sidebar-icon svg-icon' />
            ) : null}

            {/* {!show && contracted && !NavItemIcon && !image ? (
              <span className='sidebar-text-contracted'>{title[0]}</span>
            ) : null} */}

            <span className='sidebar-text'>{title}</span>
          </span>

          {badgeText ? (
            <Badge pill bg={badgeBg} text={badgeColor} className='badge-sm notification-count'>
              {badgeText}
            </Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
      <Navbar
        as={Col}
        xs={12}
        expand={false}
        collapseOnSelect
        variant='logo-green'
        className='navbar-theme-green px-4 d-md-none'
      >
        <Navbar.Brand to={'/a'} className='me-lg-5'>
          {/* <Image src={ReactHero} className="navbar-brand-dark" /> */}
        </Navbar.Brand>
        <div className='d-flex align-items-center'>
          <Navbar.Toggle as={Button} onClick={onCollapse}>
            <span className='navbar-toggler-icon' />
          </Navbar.Toggle>
        </div>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames='sidebar-transition'>
        <SimpleBar
          className={`sidebar navbar-theme-green text-white d-md-block ${show ? 'd-block' : 'd-none'}`}
        >
          <div className='sidebar-inner px-4 pt-3'>
            <div className='user-card d-flex d-md-none justify-content-between justify-content-md-center pb-4'>
              {/* <div className="d-flex align-items-center">
                <div className="avatar-lg me-4">
                  <Image
                    src={""}
                    className="card-img-top rounded-circle border-white"
                  />
                </div>
                <div className="d-block">
                  <h5 className="mb-3">Hi, Jane</h5>
                  <Button
                    variant="secondary"
                    size="sm"
                    to={"/#"}
                    className="d-inline-flex align-items-center"
                  >
                    <LogoutIcon className="icon icon-xxs me-1" /> Sign Out
                  </Button>
                </div>
              </div> */}
              <Nav.Link className='collapse-close d-md-none' onClick={onCollapse}>
                <XIcon className='icon icon-xs' />
              </Nav.Link>
            </div>
            <Nav className='flex-column pt-3 pt-md-0'>
              <NavItem
                title='Home'
                link={
                  process.env.REACT_APP_ENV === 'production'
                    ? process.env.REACT_APP_PRODUCTION_URL
                    : userToken
                      ? Routes.Dashboard.path
                      : Routes.Home.path
                }
                icon={HomeIcon}
              />
              <NavItem
                title={t('sidebar.items.how-it-works')}
                icon={QuestionMarkCircleIcon}
                link={Routes.HowItWorks.path}
              />

              <NavItem
                title={t('sidebar.items.dashboard')}
                icon={DocumentTextIcon}
                link={Routes.Dashboard.path}
              />
              <NavItem
                title={t('sidebar.items.documents')}
                link={'/medical-documents'}
                icon={ChartBarIcon}
              />
              <NavItem
                title={t('sidebar.items.ai_health_reports')}
                link={'/health-reports'}
                icon={ChartBarIcon}
              />
              <NavItem
                title={t('sidebar.items.laboratory-tests')}
                link={'/laboratory-tests'}
                icon={TableIcon}
              />
              <NavItem
                title={t('sidebar.items.genetic-profile')}
                link={Routes.GeneticProfile.path}
                icon={Dna}
              />
              <NavItem
                title={t('sidebar.items.skin-moles')}
                link={'/skin-moles'}
                icon={UserGroupIcon}
              />
              <NavItem
                title={t('sidebar.items.health-calculators')}
                link={Routes.HealthCalculators.path}
                icon={ChartPieIcon}
              />
              <NavItem
                title={t('sidebar.items.medical-persona-ai')}
                link={Routes.MedicalPersonaAi.path}
                icon={Sparkles}
              />
              {/* <NavItem
                title={t('sidebar.items.health-logs')}
                link={'/health-logs'}
                icon={TableIcon}
              /> */}
              <NavItem title={t('sidebar.items.calendar')} link={'/calendar'} icon={CalendarIcon} />
              <NavItem
                title={t('sidebar.items.shared-access-links')}
                link={Routes.SharedAccessLinks.path}
                icon={DocumentTextIcon}
              />
              <Dropdown.Divider className='my-3 border-indigo' />
              <NavItem
                title={t('sidebar.items.subscribe')}
                icon={CreditCardIcon}
                link={Routes.AccountSubscribe.path}
              />
              <NavItem
                title={t('sidebar.items.priceList')}
                icon={TableIcon}
                link={Routes.PriceList.path}
              />
              <NavItem
                title={t('sidebar.items.account')}
                icon={CashIcon}
                link={Routes.Account.path}
              />
              <NavItem
                title={t('sidebar.items.disclaimers')}
                icon={ExclamationCircleIcon}
                link={Routes.Disclaimers.path}
              />
              <NavItem
                title={t('sidebar.items.terms')}
                icon={InformationCircleIcon}
                link={Routes.Terms.path}
              />
              <NavItem
                title={t('sidebar.items.privacy')}
                icon={InformationCircleIcon}
                link={Routes.Privacy.path}
              />

              <NavItem
                title={t('sidebar.items.contact')}
                icon={MailIcon}
                link={Routes.Contact.path}
              />
              <SidebarLanguageSection onItemClick={() => setShow(false)} />

              <NavItem title={t('sidebar.items.logout')} icon={LogoutIcon} onClick={logout} />
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
